import { ADMIN_API_BASE_URL } from "../config";
import { handleApiResponse } from "../utils/commonfunction";
import {
  makeApiRequest,
  addAppTypeToParams,
  addAppTypeToBody,
} from "../utils/apiHelper";

export interface Docs {
  id: string;
  type: string;
  appType: string;
  content: Array<{ question: string; answer: string }>;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface SportsLegalDocs {
  id: string;
  name: string;
  description?: string;
  content: string[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
  sport_count: number;
}
export interface SportsLegalDocsTerm {
  id: string;
  name: string;
  description?: string;
  content: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  sport_count: number;
  type: string;
}
export interface SportsTermDocs {
  id: string;
  header: string; // Document ka title
  content: string; // React Quill HTML content
  type: "terms" | "privacy" | "rules";
  appType: "stock" | "crypto";
  is_active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface SportsLegalDocsListResponse {
  docs: Docs[];
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
}

export interface SportLegalDocsListResponse {
  universes: SportsLegalDocs[];
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
}

class SportsService {
  private getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem("adminToken");
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }

  // Sports endpoints
  async getSportsLegalDocs(
    page: number = 1,
    perPage: number = 10,
    search?: string,
    active?: boolean
  ): Promise<SportsLegalDocsListResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
    });

    if (search) params.append("search", search);
    if (active !== undefined) params.append("is_active", active.toString());

    const paramsWithAppType = addAppTypeToParams(params);

    return makeApiRequest(`/legal-docs?${paramsWithAppType}`, {
      headers: this.getAuthHeaders(),
    });
  }
  async getTermConditionDocs(
    page: number = 1,
    perPage: number = 10,
    search?: string,
    active?: boolean
  ): Promise<SportsLegalDocsListResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
    });

    if (search) params.append("search", search);
    if (active !== undefined) params.append("is_active", active.toString());

    const paramsWithAppType = addAppTypeToParams(params);

    return makeApiRequest(
      `/legal-docs/support-policies/?${paramsWithAppType}`,
      {
        headers: this.getAuthHeaders(),
      }
    );
  }

  async createDocs(sportData: Partial<Docs>): Promise<Docs> {
    const bodyWithAppType = addAppTypeToBody(sportData);
    return makeApiRequest("/legal-docs", {
      method: "POST",
      headers: this.getAuthHeaders(),
      body: JSON.stringify(bodyWithAppType),
    });
  }
  async createTermCondition(
    sportData: Partial<SportsLegalDocsTerm>
  ): Promise<SportsLegalDocsTerm> {
    const bodyWithAppType = addAppTypeToBody(sportData);
    return makeApiRequest("/legal-docs/support-policies/", {
      method: "POST",
      headers: this.getAuthHeaders(),
      body: JSON.stringify(bodyWithAppType),
    });
  }
  async updateTermCondition(
    docId: string,
    docData: Partial<Docs>
  ): Promise<Docs> {
    const bodyWithAppType = addAppTypeToBody(docData);
    return makeApiRequest(`/legal-docs/support-policies/${docId}`, {
      method: "PUT",
      headers: this.getAuthHeaders(),
      body: JSON.stringify(bodyWithAppType),
    });
  }

  async updateDocs(docId: string, docData: Partial<Docs>): Promise<Docs> {
    const bodyWithAppType = addAppTypeToBody(docData);
    return makeApiRequest(`/legal-docs/${docId}`, {
      method: "PUT",
      headers: this.getAuthHeaders(),
      body: JSON.stringify(bodyWithAppType),
    });
  }

  async deleteDocs(docId: string): Promise<void> {
    return makeApiRequest(`/legal-docs/${docId}`, {
      method: "DELETE",
      headers: this.getAuthHeaders(),
    });
  }
  async deleteTermCOndition(docId: string): Promise<void> {
    return makeApiRequest(`/legal-docs/support-policies/${docId}`, {
      method: "DELETE",
      headers: this.getAuthHeaders(),
    });
  }

  // async bulkCreateDocs(sportsDocs: Docs[]): Promise<any> {
  //   const bodyWithAppType = addAppTypeToBody(sportsDocs)
  //   return makeApiRequest('/sports/bulk-create', {
  //     method: 'POST',
  //     headers: this.getAuthHeaders(),
  //     body: JSON.stringify(bodyWithAppType),
  //   })
  // }

  // Sport Legal Docs endpoints
  // async getSportsLegalDocs(
  //   page: number = 1,
  //   perPage: number = 10,
  //   search?: string,
  //   active?: boolean
  // ): Promise<SportsLegalDocsListResponse> {
  //   const params = new URLSearchParams({
  //     page: page.toString(),
  //     per_page: perPage.toString(),
  //   })

  //   if (search) params.append('search', search)
  //   if (active !== undefined) params.append('is_active', active.toString())

  //   const paramsWithAppType = addAppTypeToParams(params)

  //   return makeApiRequest(`/sports-legaldocs?${paramsWithAppType}`, {
  //     headers: this.getAuthHeaders(),
  //   })
  // }

  // async getSportLegalDocsById(universeId: string): Promise<SportLegalDocs> {
  //   return makeApiRequest(`/sports-legaldocs/${universeId}`, {
  //     headers: this.getAuthHeaders(),
  //   })
  // }

  // async getActiveSportLegalDocs(): Promise<{ universes: SportLegalDocs[] }> {
  //   return makeApiRequest('/sports-legaldocs', {
  //     headers: this.getAuthHeaders(),
  //   })
  // }

  // async createSportLegalDocs(
  //   universeData: Partial<SportLegalDocs>
  // ): Promise<SportLegalDocs> {
  //   const bodyWithAppType = addAppTypeToBody(universeData)
  //   return makeApiRequest('/sports-legaldocs', {
  //     method: 'POST',
  //     headers: this.getAuthHeaders(),
  //     body: JSON.stringify(bodyWithAppType),
  //   })
  // }

  // async updateSportUniverse(
  //   universeId: string,
  //   universeData: Partial<SportUniverse>
  // ): Promise<SportUniverse> {
  //   const bodyWithAppType = addAppTypeToBody(universeData)
  //   return makeApiRequest(`/sports-legaldocs/${universeId}`, {
  //     method: 'PUT',
  //     headers: this.getAuthHeaders(),
  //     body: JSON.stringify(bodyWithAppType),
  //   })
  // }

  // async deleteSportUniverse(universeId: string): Promise<void> {
  //   return makeApiRequest(`/sports-legaldocs/${universeId}`, {
  //     method: 'DELETE',
  //     headers: this.getAuthHeaders(),
  //   })
  // }
}

export const sportsService = new SportsService();
